export const backendUri = `https://backendks.konnectsquare.com`
// export const backendUri = `http://localhost:3001`
// export const backendUri = `https://fuzzy-pear-chick.cyclic.cloud`
// export const backendUri = `http://13.233.147.193:3001`
export const TokenExpiryTime = 59
export const ReferalExpiryTime = 180
export const frontendUri = `https://konnectsquare.com`